export function signupToPartnerStack() {
  try {
    const growsumo = window?.growsumo;
    // growsumo's async script (snippet.growsumo.com) may not have loaded/initialized yet, or
    // could be blocked by an ad-blocker — don't crash if window.growsumo isn't there.
    if (!growsumo) return;

    growsumo.data.name = localStorage.getItem("user_name");
    growsumo.data.email = localStorage.getItem("user_email");
    growsumo.data.customer_key = localStorage.getItem("shop_id");
    growsumo.data.provider_key = localStorage.getItem("subscription_customer_uid");

    growsumo.createSignup();
  } catch (err) {
    console.error(err);
  }
}
